import { useState, useRef, useEffect } from 'react'
import {
  ModalOverlay,
  ModalWrapper,
  Header,
  ProductHeader,
  ProductInfo,
  ProductImage,
  ProductName,
  BackButton,
  StarsContainer,
  StarIcon,
  TextArea,
  SubmitButton,
  CharLimitText
} from './styles'
import ImgMock from '../../assets/img/relogio-thumb.png'
import { FaStar } from 'react-icons/fa'

import { useToast } from '../../hooks/toast'

const ModalReview = ({
  isOpen,
  onClose,
  produto,
  userID,
  idPedido,
  refetchPedidos,
  onSuccessFeedback,
  setFeedbackMessage,
  avaliacao
}) => {
  const textareaRef = useRef(null)
  const { addToast } = useToast()
  const avaliacaoDescricao = avaliacao.DescricaoAvaliacoes
  const [hover, setHover] = useState(null)
  const [selected, setSelected] = useState(null)
  const [comentario, setComentario] = useState('')
  const [loading, setLoading] = useState(false)
  const isButtonDisabled = selected === null
  const [nivelDescricao, setNivelDescricao] = useState('')

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
      setSelected(null)
      setComentario('')
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  const enviarAvaliacao = async () => {
    setLoading(true)

    const dados = {
      IdProduto: produto.IdProduto,
      QtdEstrelas: selected,
      TextoAvaliacao: comentario,
      IdCliente: 0,
      idPedido: idPedido
    }

    try {
      const resposta = await fetch(
        `${process.env.REACT_APP_URL_MAIN}/produtos/JsonGravarAvaliacaoCliente`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dados)
        }
      )

      if (resposta.status === 200) {
        if (comentario.trim().length > 0) {
          setFeedbackMessage(
            'Obrigado! Sua avaliação é muito importante para nós. Ela será revisada e em breve será publicada.'
          )
        } else {
          setFeedbackMessage(
            'Obrigado! Sua avaliação é muito importante para nós.'
          )
        }
        setSelected(null)
        setComentario('')
        if (typeof refetchPedidos === 'function') refetchPedidos()
        onClose()
        if (typeof onSuccessFeedback === 'function') onSuccessFeedback()
      } else {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Erro ao enviar avaliação. Status: ${resposta.status}`
        })
      }
    } catch (erro) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: `Erro de conexão ao enviar a avaliação ${erro}`
      })
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen || !produto) return null

  return (
    <>
      <ModalOverlay>
        <ModalWrapper>
          <Header>
            <h3>Avalie este produto</h3>
            <BackButton onClick={onClose} title="Fechar"></BackButton>
          </Header>

          <ProductHeader>
            <ProductInfo>
              <ProductImage
                src={
                  `${process.env.REACT_APP_URL_IMAGES}${produto?.IdObjetoMedia}` ||
                  ImgMock
                }
                alt={produto?.DescricaoResumida}
              />
              <ProductName>{produto?.DescricaoResumida}</ProductName>
            </ProductInfo>
            {console.log(avaliacao)}
            <StarsContainer>
              {[1, 2, 3, 4, 5].map((star) => (
                <StarIcon
                  as={FaStar}
                  key={star}
                  title={
                    avaliacaoDescricao?.find((item) => item.IdNivel === star)
                      ?.DescricaoNivel
                  }
                  $active={hover >= star || selected >= star}
                  onMouseEnter={() => {
                    setHover(star)
                  }}
                  onMouseLeave={() => {
                    setHover(null)
                  }}
                  onClick={() => {
                    setSelected(star)
                    textareaRef.current?.focus()
                  }}
                />
              ))}
            </StarsContainer>
          </ProductHeader>

          <TextArea
            ref={textareaRef}
            placeholder="Escreva sua opinião sobre o produto"
            maxLength={100}
            rows={4}
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
          />
          <CharLimitText>{comentario.length}/100 caracteres</CharLimitText>

          <SubmitButton disabled={isButtonDisabled} onClick={enviarAvaliacao}>
            Enviar Avaliação
          </SubmitButton>
        </ModalWrapper>
      </ModalOverlay>
    </>
  )
}

export default ModalReview
